var _rect, _rect2, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremiumUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2712_11595)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2712_11595",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 5H5V19H19V5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2712_11595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8861 13.75L18.9625 8.67697C18.9859 8.56659 18.9519 8.45186 18.8721 8.37208L18.2965 7.79653C18.1943 7.69428 18.0378 7.66962 17.909 7.73546L15.4731 8.98139C15.332 9.0536 15.1595 9.01637 15.0607 8.89236L12.7563 6.0006C12.6931 5.92123 12.5971 5.875 12.4956 5.875H11.5043C11.4029 5.875 11.3069 5.92123 11.2437 6.0006L8.93933 8.89236C8.84052 9.01637 8.66802 9.0536 8.52685 8.98139L6.09096 7.73546C5.96222 7.66962 5.80571 7.69428 5.70346 7.79653L5.12791 8.37208C5.04813 8.45186 5.01412 8.56659 5.03754 8.67697L6.11387 13.75H17.8861Z",
    fill: "#FFD811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43164 15.5L6.65053 16.7027C6.70821 17.0196 6.98428 17.25 7.30642 17.25H16.6939C17.016 17.25 17.2921 17.0196 17.3498 16.7027L17.5687 15.5H6.43164Z",
    fill: "#FEDB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8865 13.75H6.11426L6.43188 15.5H17.5688L17.8865 13.75Z",
    fill: "#FFA62E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2712_11595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumUser);
export default __webpack_public_path__ + "static/media/PremiumUser.9557a606aa7bb59c2a42a375db603b10.svg";
export { ForwardRef as ReactComponent };